<template>
  <div id="app" v-cloak>
    <div id="ie-tip" v-if="(type==='IE'||type==='Edge')&&this.$route.path!=='/login'&&this.$route.path!=='/register'"
         style="display: block;">
      <div
          style="background: rgb(249, 243, 207); border: 1px solid rgb(247, 234, 172); height: 30px; text-align: center; color: rgb(51, 51, 51); line-height: 30px; font-size: 14px;">
        <span>
          检测到您的浏览器版本过低，可能导致文件上传下载或支付功能无法正常使用，建议升级您的浏览器，或使用推荐浏览器
          <a style="color: rgb(45, 140, 240);" href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank"
             rel="noopener noreferrer">
            Google Chrome
          </a>
          、
          <a style="color: rgb(45, 140, 240);" href="https://www.microsoft.com/zh-cn/edge" target="_blank"
             rel="noopener noreferrer">
            Microsoft Edge
          </a>
          、
          <a style="color: rgb(45, 140, 240);" href="https://www.firefox.com.cn/" target="_blank"
             rel="noopener noreferrer">
            Firefox
          </a>
          。
        </span>
        <span id="ie-tip-bar-close"
              style="border-radius: 10px; width: 15px; height: 15px; color: rgb(142, 101, 41); line-height: 15px; font-size: 10px; margin-left: 15px; display: inline-block; cursor: pointer; background-color: rgb(247, 234, 172);"
              onclick="javascript:var b = document.getElementById('ie-tip');b.innerHTML = '';b.style = 'display:none';">
          X
        </span>
      </div>
    </div>
    <auth-popup />
    <workspace-side-rail
      v-if="showWorkspaceSideRail"
      :expanded="workspaceSideRailExpanded"
      @toggle="toggleWorkspaceSideRail"
    />
    <div
      :class="{
        'workspace-side-rail-frame': showWorkspaceSideRail,
        'workspace-side-rail-frame--expanded': showWorkspaceSideRail && workspaceSideRailExpanded,
        'workspace-side-rail-frame--content-only': workspaceSideRailContentOnly
      }"
    >
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import AuthPopup from '@/components/auth/AuthPopup.vue'
import WorkspaceSideRail from '@/components/WorkspaceSideRail.vue'

export default {
  name: 'app',
  components: { AuthPopup, WorkspaceSideRail },
  data() {
    return {
      type: '',
      workspaceSideRailExpanded: false
    }
  },
  computed: {
    showWorkspaceSideRail() {
      const path = this.$route.path
      return path === '/translate' ||
        path === '/rag' ||
        path === '/smart-classify' ||
        path === '/extract' ||
        path === '/list' ||
        path === '/list-pro' ||
        path === '/about' ||
        path === '/category-tool' ||
        path === '/scholar' ||
        path.startsWith('/pdfView/') ||
        path.startsWith('/imageView/') ||
        path.startsWith('/scholar/')
    },
    workspaceSideRailContentOnly() {
      return this.$route.path === '/category-tool' || this.$route.path === '/scholar'
    }
  },
  created() {
    //this.detectZoom();
  },
  mounted() {
    const that = this;
    window.addEventListener('message', function (e) {
      if (e.data.data === "hidden") {
        document.getElementsByTagName("html")[0].className = "hiddenClass";
      }
    })
    this.type = this.getType()
    console.log(this.type)
  },
  methods: {
    toggleWorkspaceSideRail() {
      this.workspaceSideRailExpanded = !this.workspaceSideRailExpanded
    },
    detectZoom() {
      let ratio = 0,
          screen = window.screen,
          ua = navigator.userAgent.toLowerCase();
      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth;
      }
      if (ratio) {
        ratio = Math.round(ratio * 100);
      }
      if (ratio !== 100) {
        const h = this.$createElement;
        this.$notify({
          customClass: 'notifyClass',
          duration: 10000,
          title: '',
          message: h('span', {style: 'color: #080808;font-size: 12px;'},
              `您的浏览器目前处于${ratio}%缩放状态。页面可能会出现错位或功能键不全，建议100%大小显示`)
        });
      }
    },
    getType() {
      var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串

      var isOpera = userAgent.indexOf("Opera") > -1;
      //判断是否Opera浏览器
      if (isOpera) {
        return "Opera"
      }
      //判断是否Firefox浏览器
      if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
      }
      //判断是否chorme浏览器
      if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
      }
      //判断是否Safari浏览器
      if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
      }
      //判断是否IE浏览器
      if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
        return "IE";
      }
      //判断是否Edge浏览器
      if (userAgent.indexOf("Trident") > -1) {
        return "Edge";
      }
    }
  }
}
</script>

<style>
#app {
  position: relative;
  min-height: 100vh;
}

.workspace-side-rail-frame {
  --workspace-side-rail-width: 54px;

  min-width: 0;
  box-sizing: border-box;
}

.workspace-side-rail-frame--expanded {
  --workspace-side-rail-width: 200px;
}

.workspace-side-rail-frame .home-nav,
.workspace-side-rail-frame .site-footer-shell {
  width: 100% !important;
  margin-left: 0 !important;
  box-sizing: border-box;
}

.workspace-side-rail-frame .home-nav {
  z-index: 50 !important;
}

.workspace-side-rail-frame .site-footer-shell {
  position: relative !important;
  z-index: 49 !important;
}

.workspace-side-rail-frame--content-only .home-nav,
.workspace-side-rail-frame--content-only .site-footer-shell {
  width: 100% !important;
  margin-left: 0 !important;
}

.workspace-side-rail-frame--content-only .workspace-side-rail-content {
  padding-left: var(--workspace-side-rail-width);
  box-sizing: border-box;
  transition: padding-left 0.18s ease;
}

.workspace-side-rail-frame--content-only .scholar-main.workspace-side-rail-content-inset {
  width: calc(100% - var(--workspace-side-rail-width));
  margin-left: var(--workspace-side-rail-width);
  transition: width 0.18s ease, margin-left 0.18s ease;
}

.workspace-side-rail-frame .scholar-detail-shell,
.workspace-side-rail-frame .smart-classify-page {
  overflow: visible !important;
}

@media (max-width: 768px) {
  .workspace-side-rail-frame .home-nav,
  .workspace-side-rail-frame .site-footer-shell {
    width: 100% !important;
    margin-left: 0 !important;
  }

  .workspace-side-rail-frame--content-only .workspace-side-rail-content {
    padding-left: 0;
  }

  .workspace-side-rail-frame--content-only .scholar-main.workspace-side-rail-content-inset {
    width: 100%;
    margin-left: 0;
  }
}

/* 桌面工作台统一使用截图所示的全局窄侧栏，隐藏各页面遗留的宽版导航。 */
@media (min-width: 768.01px) {
  /* 页头和页脚保持全宽，只让中间工作区为固定侧栏腾出空间。 */
  #app > .workspace-side-rail-frame .new-upload-site-shell.workspace-fullscreen-page .page .group_1 .box_1 .group_3,
  #app > .workspace-side-rail-frame .rag-workbench-page .group_3,
  #app > .workspace-side-rail-frame .smart-workspace-shell,
  #app > .workspace-side-rail-frame .material-extract-body,
  #app > .workspace-side-rail-frame .advantages-main,
  #app > .workspace-side-rail-frame .pdf-preview .container,
  #app > .workspace-side-rail-frame .image-preview .container,
  #app > .workspace-side-rail-frame .scholar-saved-main,
  #app > .workspace-side-rail-frame .scholar-detail-main,
  #app > .workspace-side-rail-frame .scholar-entity-main {
    width: calc(100% - var(--workspace-side-rail-width)) !important;
    margin-left: var(--workspace-side-rail-width) !important;
    box-sizing: border-box;
    transition: width 0.18s ease, margin-left 0.18s ease;
  }

  #app > .workspace-side-rail-frame .task-list-page .list-page-intro {
    width: calc(100% - var(--workspace-side-rail-width) - 48px) !important;
    margin-right: 24px !important;
    margin-left: calc(var(--workspace-side-rail-width) + 24px) !important;
    transition: width 0.18s ease, margin-left 0.18s ease;
  }

  #app > .workspace-side-rail-frame .task-list-page .tip-alert-content,
  #app > .workspace-side-rail-frame .task-list-page .list-content {
    width: calc(100% - var(--workspace-side-rail-width)) !important;
    margin-left: var(--workspace-side-rail-width) !important;
    box-sizing: border-box;
    transition: width 0.18s ease, margin-left 0.18s ease;
  }

  .workspace-side-rail-frame .site-tool-sidebar,
  .workspace-side-rail-frame .material-extract-nav,
  .workspace-side-rail-frame .pdf-preview .container > .el-aside,
  .workspace-side-rail-frame .image-preview .container > .el-aside,
  .workspace-side-rail-frame .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 {
    display: none !important;
  }

  .workspace-side-rail-frame .new-upload-site-shell.workspace-fullscreen-page .page .group_1 .box_1 .group_3 .new-container .box_4 {
    width: 100% !important;
    margin-left: 0 !important;
  }
}

.hiddenClass {
  overflow-y: hidden !important;
}
</style>
